import React, { Fragment, useContext, useEffect, useState } from 'react';
import { APIContext } from 'src/components/Contexts/APIContext'
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SaveIcon from '@mui/icons-material/Save';
import { ClientSummaryViewModel } from './ViewModels/ClientSummaryViewModel';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import { useSnackbar } from 'notistack';
import CircularProgress from '@mui/material/CircularProgress';
import AvayaCallData from '../Memo/ViewModels/AvayaCallData';
import AvayaCallDataDisplay from '../Memo/AvayaCallDataDisplay';

interface IClientSummaryProps {
    systemId: string
    callRefId: string | null
    avayaCallData?: AvayaCallData
    memoView?: boolean
}

export default function ClientSummary(props: IClientSummaryProps) {
    const { get, post, showMessage, loading } = useContext(APIContext);
    const [summary, setSummary] = useState<ClientSummaryViewModel | null>(null);
    const [text, setText] = useState<string>('');
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        getSummary();
    }, [])

    const getSummary = () => {
        if (props.callRefId !== null && props.systemId !== null) {
            get(
                'AIAnalysis',
                `GetClientNote?systemPk=${props.callRefId}`,
                (data) => {
                    setText(data)
                    return;
                },
                () => {
                    get(
                        'AIAnalysis',
                        `GetClientSummary?systemId=${props.systemId}`,
                        (data) => {
                            setSummary(data)
                            formText(data)
                        }
                    )
                })
        }
    }

    const formText = (data: ClientSummaryViewModel) => {
        let newText = ''
        for (var i = 0; i < data.rows.length; i++) {
            newText += data.rows[i].question + '\n' + data.rows[i].answer;
            if (i != data.rows.length - 1) {
                newText += '\n\n'
            }
        }
        setText(newText);
    }

    const handleChange = (event: any) => {
        setText(event.target.value)
    }

    const stopCopying = (e) => {
        enqueueSnackbar('The Copy and Cut Shortcuts are disabled for this box, please use the button provided underneath this textbox', { variant: 'warning' });
        e.preventDefault();
    };

    const copySummaryToClipboard = () => {
        post('Info', `AddCallNote`, (
            {
                systemPK: props.callRefId,
                note: text,
                type: 'Client Summary'
            }))
        navigator.clipboard.writeText(text);
        showMessage('success', 'Summary copied to clipboard');
    }



    return (
        <Fragment>
            {
                loading ?
                    <Grid
                        container
                        justifyContent='center'
                        alignItems='center'
                        height='100vh'>
                        <Grid>
                            <CircularProgress />
                        </Grid>
                    </Grid>
                    :
                    <>
                        {(summary !== null || text !== '') ?
                            <Grid container justifyContent='space-between' sx={{ width: '100%' }}>
                                {
                                    props.memoView && props.avayaCallData &&
                                    <AvayaCallDataDisplay avayaCallData={props.avayaCallData} />
                                }
                                <Grid size={12}>
                                    <Alert severity='info' style={{ paddingTop: '4px', paddingBottom: '4px' }}>
                                        These notes are editable
                                    </Alert>
                                </Grid>
                                <Grid size={12}>
                                    <TextField
                                        multiline
                                        value={text}
                                        onChange={handleChange}
                                        onCopy={stopCopying}
                                        onCut={stopCopying}
                                        fullWidth
                                        disabled={loading}
                                    />
                                </Grid>
                                <Grid size={12} textAlign='end'>
                                    <Tooltip title={<>Save any edits and copy notes to the clipboard</>}>
                                        <Button disabled={loading} onClick={() => copySummaryToClipboard()}>
                                            <SaveIcon />+<ContentCopyIcon />
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            :
                            <Grid container
                                justifyContent='center'
                                alignItems='center'
                                height={props.memoView ? '100vh' : undefined}>
                                <Grid>
                                    <Typography variant='h5'>
                                        No client summary found for this call
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                    </>
            }
        </Fragment >
    )
}